export default __webpack_public_path__ + "static/media/coffeetable.5f2d39b0.jpg";